module.exports = __webpack_public_path__ + "static/media/netflix_round.2b8e6cee.svg";